import { Spin as AntdSpin, SpinProps as AntdSpinProps } from "antd";
import React, { FC } from "react";
import * as styles from "./Spin.css";

export interface SpinProps extends AntdSpinProps {
  blur?: boolean;
}
const Spin: FC<SpinProps> = ({ blur, children, ...props }) => {
  return (
    <AntdSpin {...props}>
      <div className={blur && props.spinning ? styles.spinBlur : undefined}>
        {children}
      </div>
    </AntdSpin>
  );
};

export default Spin;
